import { DashboardSdk } from '@bringg/frontend-utils';
import * as Bringg from '@bringg/types';
import { cloneDeep, head } from 'lodash';

import { DemoFlows, DemoSettings, DemoSettingsField } from '../../types';

interface DriversInTeam {
  users: Bringg.Driver[];
  team: Bringg.Team;
}

const getTeamsSettingField = (demo: DemoSettings): DemoSettingsField =>
  demo.fields[demo.fields.findIndex(({ name }) => name === 'team')];

const filterByUsers = async (demoType: DemoFlows, demoTeams: DemoSettingsField, dashboardSdk: DashboardSdk) => {
  const filteredTeamsOptions = demoTeams.options?.filter((team) => team?.extras?.demoFlow?.includes(demoType)) ?? [];
  if (demoType !== DemoFlows.InternalDriver) {
    return filteredTeamsOptions;
  }

  const teamsWithUsers: DriversInTeam[] = await Promise.all(
    filteredTeamsOptions.map(async (team) => {
      const users = await dashboardSdk.sdk.users.getDriversByTeam(team.id);

      return { users, team };
    })
  );

  return teamsWithUsers.reduce((arr: Bringg.Team[], teamWithusers: DriversInTeam) => {
    teamWithusers.users.length > 0 && arr.push(teamWithusers.team);

    return arr;
  }, []);
};

export const filterTeams = (demoList: DemoSettings[], dashboardSdk: DashboardSdk): Promise<DemoSettings[]> =>
  Promise.all(
    demoList.map(async (demo) => {
      const teamsIndex = demo.fields.findIndex(({ name }) => name === 'team');
      const demoTeams = getTeamsSettingField(demo);
      const demoTeamsLength = demoTeams.options?.length ?? 0;

      const updatedDemo = cloneDeep(demo);
      const filteredDemoTeams = await filterByUsers(demo.demoType, demoTeams, dashboardSdk);

      updatedDemo.fields[teamsIndex].options = filteredDemoTeams;
      updatedDemo.fields[teamsIndex].value = head(filteredDemoTeams);

      const filteredDemoTeamsLength = filteredDemoTeams?.length ?? 0;

      updatedDemo.fields[teamsIndex].isAllFilteredOut =
        filteredDemoTeamsLength === 0 && demoTeamsLength > filteredDemoTeamsLength;

      return updatedDemo;
    })
  );

export const isAllTeamsFiltered = (settings: DemoSettings): boolean | undefined => {
  return getTeamsSettingField(settings).isAllFilteredOut;
};
